import { Link, LinkProps, SystemStyleObject } from "@chakra-ui/react"
import { NavLink } from "react-router-dom"

export interface RouterNavLinkProps extends Omit<LinkProps, "as" | "href"> {
  to: string
  children: React.ReactNode
  _hover?: SystemStyleObject
  activeStyle?: {
    borderLeft?: string
    borderLeftColor?: string
    boxShadow?: string
    color?: string
  }
}

export const RouterNavLink = ({
  to = "",
  children,
  _hover,
  activeStyle,
  ...rest
}: RouterNavLinkProps) => {
  return (
    <NavLink to={to} style={{ textDecoration: "none" }}>
      {({ isActive }) => (
        <Link
          as="span"
          {...rest} // Default styles and other props are applied here
          _hover={_hover}
          style={isActive ? activeStyle : {}} // Apply active styles when isActive is true
        >
          {children}
        </Link>
      )}
    </NavLink>
  )
}
